import { lazy, Suspense } from "react";
import { QueryClient } from "@tanstack/query-core";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import { SetErrorMessageType } from "@/app/providers/ReactContextProvider/types";
import { cabinetRouter } from "@/router/cabinetRouter";
import { commonRouter } from "@/router/commonRouter";
import { indexRedirect } from "@/router/loaders/indexRedirect";
import { paymentLoader } from "@/router/loaders/paymentLoader";
import { RouterUtility } from "@/router/providers/RouterUtility";
import { signupRouter } from "@/router/signupRouter";
import { RouterPath } from "@/router/types";
import { LayoutBase } from "@/widgets/Layout/Base";

const ErrorPage = lazy(() => import("@/pages/ErrorPage"));

export default (
  queryClient: QueryClient,
  setErrorMessage: SetErrorMessageType,
) =>
  createBrowserRouter(
    createRoutesFromElements(
      <Route
        element={<RouterUtility />}
        errorElement={
          <Suspense fallback={null}>
            <ErrorPage />
          </Suspense>
        }
      >
        <Route path="*" loader={indexRedirect} />
        {commonRouter}
        {signupRouter(queryClient, setErrorMessage)}
        {cabinetRouter(queryClient, setErrorMessage)}
        <Route element={<LayoutBase />}>
          <Route
            path={RouterPath.Payment}
            loader={paymentLoader(queryClient, setErrorMessage)}
            lazy={() => import(/* webpackPrefetch: true */ "@/pages/Payment")}
          />
        </Route>
      </Route>,
    ),
  );
